/*
 * @Author: Chris 
 * @Date: 2022-07-27 11:17:38 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-11-07 17:50:28
 */

<template>
  <div class="login">
    <Headerwhtiout></Headerwhtiout>
    <div class="login_body">
      <div class="body_frame">
        <div class="frame_left">
          <div class="left_name">
            <div class="name_well">welcome</div>
            <div class="name_line"></div>
            <div class="name_cn">用户管理中心</div>
            <div class="name_en">USER MANAGEMENT CENTER</div>
          </div>
        </div>
        <div class="frame_right">
          <div class="right_logo">
            <img
              class="logo_img"
              src="../../assets/IMG/login/Clogo.png"
              alt=""
            />
          </div>
          <div class="right_from">
            <div
              class="from_choose"
              v-if="$store.state.LoginstatusbyPhone == 1"
            >
              <div
                :class="choosedMethod == 1 ? 'choose' : ''"
                @click="chooseLoginM(1)"
              >
                手<span :class="choosedMethod == 1 ? 'choose_span' : ''"
                  >机号码登</span
                >录
              </div>
              <div
                :class="choosedMethod == 0 ? 'choose' : ''"
                @click="chooseLoginM(0)"
              >
                账<span :class="choosedMethod == 0 ? 'choose_span' : ''"
                  >号密码登</span
                >录
              </div>
            </div>
            <LoginAccount v-if="choosedMethod == 0"></LoginAccount>
            <LoginPhone v-if="choosedMethod == 1"></LoginPhone>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Headerwhtiout from "../../components/headerWhitOutUser/index.vue";
import LoginAccount from "./components/login_account.vue";
import LoginPhone from "./components/login_phone.vue";
export default {
  name: "Login",
  components: {
    Headerwhtiout,
    LoginAccount,
    LoginPhone,
  },
  data() {
    return {
      choosedMethod: 1,
    };
  },
  mounted() {
    this.$store.commit("SET_LoginstatusbyPhone", 1);
  },

  methods: {
    /**
     * 选择登录方式
     * 0：账号密码
     * 1：电话号码
     * */

    chooseLoginM(data) {
      this.choosedMethod = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  height: 100vh;
  min-height: 53.125rem;
  background-image: url("../../assets/IMG/login/bg.png");
  background-size: 100% 100%;

  .login_body {
    width: 100%;
    height: calc(100% - 3.75rem);
    display: flex;
    justify-content: center;
    z-index: 1;
    .body_frame {
      margin-top: 5%;
      width: 99.0625rem;
      height: 75%;
      background: rgba(255, 255, 255, 0.7);
      border-radius: 1rem;
      box-shadow: -0.25rem 0rem 0.75rem 0.0625rem rgba(0, 0, 0, 0.2);
      display: flex;
      .frame_left {
        user-select: none;
        height: 100%;
        width: 36.5625rem;
        .left_name {
          margin-left: 7.5rem;
          margin-top: 3.75rem;
          .name_well {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 1.625rem;
            line-height: 2.25rem;
            color: #333333;
            margin-bottom: 0.3125rem;
          }
          .name_line {
            width: 13.5rem;
            height: 0rem;
            border-top: 0.25rem solid #3e3a39;
            margin-bottom: 0.3125rem;
          }
          .name_cn {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 2.25rem;
            line-height: 3.125rem;
            color: #333333;
          }
          .name_en {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 0.8125rem;
            line-height: 1.125rem;
            letter-spacing: 0.1em;
            color: #cccccc;
          }
        }
      }
      .frame_right {
        box-shadow: -0.25rem 0rem 0.75rem 0.0625rem rgba(0, 0, 0, 0.1);
        border-radius: 0 1rem 1rem 0;
        background: #fff;
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        background-image: url("../../assets/IMG/login/bg_ele.png");
        background-repeat: no-repeat;
        background-position: right 0rem bottom 0rem;

        .right_logo {
          user-select: none;
          margin-top: 12%;
          width: 36.125rem;
          height: 5.5625rem;
          .logo_img {
            width: 100%;
            height: 100%;
          }
        }

        .right_from {
          margin-top: 5%;
          width: 18.75rem;

          .from_choose {
            user-select: none;
            height: 2.0625rem;
            margin-bottom: 4vh;
            width: 100%;
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: 1.25rem;
            line-height: 1.75rem;
            color: #999999;
            cursor: pointer;
            padding-bottom: 0.1875rem;
            transition: all 0.2s ease-in-out;
            .choose {
              padding-bottom: 0.1875rem;
              transition: all 0.2s ease-in-out;
              color: #b7282d;
              font-weight: 500;
              font-size: 1.25rem;
              line-height: 1.75rem;
              // border-bottom: .1875rem solid #b7282d;
              text-decoration: none;
            }

            .choose_span {
              transition: all 0.2s ease-in-out;
              border-bottom: 0.1875rem solid #b7282d;
            }
          }
        }
      }
    }
  }
}
</style>